import React, { useState } from 'react';
import { useToast } from '../../contexts/ToastContext';
import './ShareResultsModal.scss';

const ShareResultsModal = ({ 
  isOpen, 
  onClose, 
  attempts, 
  currentItem, 
  categories, 
  gameName,
  itemName,
  isDailyMode,
  todayDate,
  currentStreak,
  gameRoute
}) => {
  const { addToast } = useToast();
  const [isCopying, setIsCopying] = useState(false);

  if (!isOpen) return null;

  const generateEmojiGrid = () => {
    return attempts.map(attempt => {
      return categories.map(cat => {
        const result = attempt.results[cat.key];
        switch (result) {
          case 'correct':
            return '🟩';
          case 'partial':
          case 'partial-up':
          case 'partial-down':
            return '🟨';
          case 'incorrect':
          default:
            return '⬛';
        }
      }).join('');
    }).join('\n');
  };

  const generateShareText = () => {
    return `Guess Nexus - ${gameName}
${todayDate}

${generateEmojiGrid()}

guessnexus.com${gameRoute}`;
  };

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  const handleCopyToClipboard = async () => {
    setIsCopying(true);
    const shareText = generateShareText();

    try {
      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(shareText);
      } else {
        // Fallback for older browsers or non-HTTPS
        const textArea = document.createElement('textarea');
        textArea.value = shareText;
        textArea.style.position = 'fixed';
        textArea.style.left = '-999999px';
        textArea.style.top = '-999999px';
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();
        document.execCommand('copy');
        textArea.remove();
      }

      addToast({
        message: 'Results copied to clipboard! Share your victory!',
        type: 'success',
        autoClose: true
      });
      
      onClose();
    } catch (error) {
      console.error('Error copying to clipboard:', error);
      addToast({
        message: 'Failed to copy. Please try selecting and copying manually.',
        type: 'error',
        autoClose: true
      });
    } finally {
      setIsCopying(false);
    }
  };

  return (
    <div className="share-results-modal__overlay" onClick={handleOverlayClick}>
      <div className="share-results-modal__container">
        <div className="share-results-modal__header">
          <h2 className="share-results-modal__title">Share Your Results</h2>
          <button 
            onClick={onClose}
            className="share-results-modal__close-button"
            aria-label="Close modal"
          >
            ×
          </button>
        </div>

        <div className="share-results-modal__content">
          <div className="share-results-modal__preview">
            <pre className="share-results-modal__text">
              {generateShareText()}
            </pre>
          </div>

          <div className="share-results-modal__footer">
            <button
              type="button"
              onClick={onClose}
              className="share-results-modal__cancel-btn"
            >
              Cancel
            </button>
            <button
              onClick={handleCopyToClipboard}
              disabled={isCopying}
              className="share-results-modal__copy-btn"
            >
              {isCopying ? 'Copying...' : 'Copy to Clipboard'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ShareResultsModal;